{
  "words":[
    {
      "word":"Mama",
      "pronounce":"[Ma-ma]",
      "wordtype": "Substantiv",
      "description": "Die Frau, die dich geboren hat und dich liebt Egal was, diejenige, die ihr Kind voran stellt sich selbst und auf die Sie sich vor allem verlassen können. Sie ist geduldig, freundlich, warmherzig, liebt, nährt, lehrt, schützt, tröstet, führt, unterstützt, pflegt, umarmt, schätzt und beruhigt. Sie ist die Schöpferin und Bewahrerin kostbarer Erinnerungen. Sie hat den härtesten, aber lohnendsten Job der Welt."
    },
    {
      "word":"Papa",
      "pronounce":"[Pa-pa]",
      "wordtype": "Substantiv",
      "description": "Der Mann mit dem Silber im Haar und dem Gold im Herzen. Ein Fürsorger, Held, Vorbild und Beschützer, der sich oft für seine Familie aufopfert. Jemand, der alles schaffen und reparieren kann. Er ist außen hart und zäh, aber innen weich und fürsorglich.<br/>Gibt die stärksten Umarmungen."
    },
    {
      "word":"Lehrerin",
      "pronounce":"[Leh-re-rin]",
      "wordtype": "Substantiv",
      "description": "Jemand, der Kinder unterrichtet. Sie inspiriert und hilft ihnen zu wachsen, sie hat Augen im Rücken, ist geduldig und hilft Kindern, die beste Version von sich selbst zu sein. Eine liebe und gute Lehrerin hinterlässt einen lebenslangen Eindruck in deinem Herzen."
    },
    {
      "word":"Meister",
      "pronounce":"[Meis-ter]",
      "wordtype": "Substantiv",
      "description": "Jemand, der Kinder unterrichtet. Er inspiriert sie und hilft ihnen zu wachsen, er hat Augen im Rücken, ist geduldig und hilft Kindern, die beste Version ihrer selbst zu sein. Ein lustiger und guter Meister hinterlässt einen lebenslangen Eindruck in deinem Herzen."
    },
    {
      "word":"Tante",
      "pronounce":"[Tan-te]",
      "wordtype": "Substantiv",
      "description": "Eine absolute Vertrauensperson und einzigartige Lebensgefährtin, auf die man sich immer verlassen kann. Sie bewahrt Geheimnisse wie eine Schwester und teilt die besten Momente wie eine beste Freundin. Mit ihr kannst du Pferde stehlen und all die spannenden Abenteuer erleben, die für Mama zu gefährlich sind. Genau wie eine Mama, nur cooler und mit weniger Regeln."
    },
    {
      "word":"Onkel",
      "pronounce":"[On-kel]",
      "wordtype": "Substantiv",
      "description": "Einer, der dir hilft, Unfug zu treiben und dich immer zum Lachen bringt, der Berater, Helfer und Beschützer, eine Quelle grenzenlosen Spaßes und Lachens. Derjenige, der geduldig, großzügig und freundlich ist, ein Mann, der geschätzt und geliebt wird."
    },
    {
      "word":"Großvater",
      "pronounce":"[Groß-va-ter]",
      "wordtype": "Substantiv",
      "description": "Der Mann, von dem man alles lernen kann, der in jeder Situation Rat weiß und immer die passende Weisheit parat hat. Er kann alles reparieren, was selbst Papa nicht konnte. Er liebt seine Enkelkinder mehr als alles andere. Er hat die verrücktesten Ideen und ist der größte Spaßvogel. Für die ganze Familie ist er eine Quelle der Liebe und Geborgenheit."
    },
    {
      "word":"Großmutter",
      "pronounce":"[Groß-mu-ter]",
      "wordtype": "Substantiv",
      "description": "Eine Frau mit einem Herz aus Gold. Sie liebt ihre Enkelkinder über alles und bewahrt alle ihre Geheimnisse. Sie liebt es, Süßigkeiten zu verteilen, Küsse, Umarmungen und viel Liebe. Sie ist die beste Bäckerin der Welt und lässt Sie nie ohne einen vollen Bauch nach Hause gehen."
    },
    {
      "word":"Bruder",
      "pronounce":"[Bru-der]",
      "wordtype": "Substantiv",
      "description": "Allererster Spielkamerad und größter Rivale zugleich; der Mensch, auf den immer Verlass ist (spätestens wenn es hart auf hart kommt); der Freund, dem du bedenkenlos alle Geheimnisse anvertrauen kannst; liebt dich auch, wenn du ihn auf die Palme bringst"
    },
    {
      "word":"Schwester",
      "pronounce":"[Schwes-ter]",
      "wordtype": "Substantiv",
      "description": "Eine Frau, die denselben Vater und/oder dieselbe Mutter hat, eine Beschützerin, die ein Band teilt, das niemand sonst versteht, eine Hüterin von Geheimnissen, die immer bereit ist, durch dick und dünn zu helfen. Eine beste Freundin fürs Leben, die mehr geliebt wird, als sie je wissen wird."
    },
    {
      "word":"Tochter",
      "pronounce":"[Toch-ter]",
      "wordtype": "Substantiv",
      "description": "Eines der schönsten Mädchen, die diese Welt zu bieten hat. Sie ist ein kleines Mädchen, das zu deinem besten Freund heranwächst. Jemand, mit dem man lacht, mit dem man träumt und den man von ganzem Herzen liebt."
    },
    {
      "word":"Liebe",
      "pronounce":"[Lie-be]",
      "wordtype": "Substantiv",
      "description": "Liebe ist tiefe Akzeptanz und Zuneigung, Wohlwollen oder Hingabe für einen anderen oder möglicherweise für sich selbst. Sie kann sich auch auf ein Tier, eine Sache oder einen Gegenstand beziehen. Bei einem Schatz geht es nicht immer um Geld, aber manchmal wird er auch zur Liebe gezählt. Einander zu verstehen, ohne ein Wort, das wirklich Liebe ist, das ist es, was dazu gehört."
    },
    {
      "word":"Schatz",
      "pronounce":"[Schatz]",
      "wordtype": "Substantiv",
      "description": "Ein Kosename für deinen Freund, deine Freundin, eine beste Freundin, jemanden, mit dem du dich gut verstehst. Es ist jemand, mit dem man eine gute Beziehung hat. Ihr versteht euch sehr gut. Darling ist ein Verkleinerungswort für Schatz."
    },
    {
      "word":"Sohn",
      "pronounce":"[Sohn]",
      "wordtype": "Substantiv",
      "description": "Ein unbezahlbarer Gewinn für die Familie. Und das nicht nur, weil er eines Tages mehr essen kann, als er selbst wiegt. Er zieht es vor, sich mit einer Reihe von unverständlichen Lauten zu verständigen. Aber gleichzeitig bringt er so viel Liebe, Stolz und gute Laune mit, dass man ihm nichts vorwerfen kann."
    },
    {
      "word":"Familie",
      "pronounce":"[Fa-mi-lie]",
      "wordtype": "Substantiv",
      "description": "Menschen, die sich kennen, einander vertrauen und sich immer gegenseitig unterstützen. Auch wenn Liebe und Chaos hier manchmal dicht beieinander liegen, bleibt es der Ort, an dem das Herz zu Hause ist. Es gibt Wurzeln und Flügel und ist füreinander da, in guten und in schlechten Zeiten, und für das Leben."
    },
    {
      "word":"Prost",
      "pronounce":"[Prost]",
      "wordtype": "zwischenruf",
      "description": "Wird ausgesprochen, wenn man mit einem Trinkspruch den Wunsch nach Erlösung bekräftigt, d. h. auf das Wohlergehen von jemandem trinkt, einschließlich guter Gesundheit. Der Trinkspruch wird dann durch Erheben oder Anklopfen des Glases bestätigt, wobei zunächst das gefüllte eigene Trinkglas gegen das gefüllte Glas eines anderen geklopft wird. Man nimmt einen Schluck und sagt dabei das Wort „Prost“."
    },
    {
      "word":"Pensionado",
      "pronounce":"[Pen-si-o-na-do]",
      "wordtype": "Substantiv",
      "description": "Informeller Name für einen Rentner. Vom Ursprung her vor allem zur Bezeichnung eines (oft wohlhabenden) Rentners, der seine Rente für einen Teil des Jahres in einem sonnenverwöhnten Land als Überwinterer genießt und dabei die deutsche Rente behält."
    },
    {
      "word":"Freunde",
      "pronounce":"[Freun-de]",
      "wordtype": "adjektiv",
      "description": "Leute kommen zu dir nach Hause, essen dein ganzes Essen, trinken deinen ganzen Wein und bringen dich zum Lachen, bis du dir in die Hose machst."
    },
    {
      "word":"Großeltern",
      "pronounce":"[Groß-el-tern]",
      "wordtype": "Substantiv",
      "description": "Sie sind wie Eltern, nur ohne alle Regeln. Sie haben immer ein offenes Ohr und stehen dir mit guten Ratschlägen zur Seite. Sie sind heimliche Finanziers und große Geschichtenerzähler. Von ihnen kann man eine Menge lernen."
    },
    {
      "word":"Beste Freundin",
      "pronounce":"[Bes-te-freun-din]",
      "wordtype": "Substantiv",
      "description": "Ist immer für dich da. Hört dir gerne zu, versteht dich aber auch ohne Worte. Bekommt stets die erste Nachricht bei guten oder schlechten Neuigkeiten. Liebt dich so wie du bist und das ein Leben lang.<br/>(vgl. 'Lieblingsmensch' oder 'Schwester im Herzen')"
    },
    {
      "word":"Bester Freund",
      "pronounce":"[Bes-ter-freund]",
      "wordtype": "Substantiv",
      "description": "der Kerl, der ein Leben lang für dich da ist; er ist immer ehrlich und wäscht dir den Kopf, wenn du Mist baust, vertuscht es aber sicher vor anderen; dein ewiger Ratgeber und -nehmer; sorgt stets dafür, dass du sicher Zuhause ankommst.<br/>(s.a. 'Buddy' oder 'Bro')"
    },
    {
      "word":"Alkohol",
      "pronounce":"[Al-ko-hol]",
      "wordtype": "Substantiv",
      "description": "beherrscht alle Sprachen; löst keine Probleme, tut Milch allerdings auch nicht; <br/>(ugs. auch 'Suff' oder 'Sprit')"
    },
    {
      "word":"Erzieher",
      "pronounce":"[Er-zie-her]",
      "wordtype": "Substantiv",
      "description": "Ein Mann, der Kinder und Jugendliche betreut; jemand, der sich den ganzen Tag mit den lieben Kleinen beschäftigt; Geschichtenerzähler; Tränentrockner (s.a. Superheld)"
    },
    {
      "word":"Erzieherin",
      "pronounce":"[Er-zie-he-rin]",
      "wordtype": "Substantiv",
      "description": "eine Frau, die Kinder und Jugendliche betreut; jemand, der sich den ganzen Tag mit den lieben Kleinen beschäftigt; Geschichtenerzählerin; Tränentrocknerin (s.a. Superheldin)"
    },
    {
      "word":"Freundschaft",
      "pronounce":"[Freund-schaft]",
      "wordtype": "Substantiv",
      "description": "ist eine Herzensangelegenheit, die auf Vertrauen und Zuneigung beruht; ein Band zwischen zwei Seelen, das weder Raum noch Zeit trennen können"
    },
    {
      "word":"Heimat",
      "pronounce":"[Freund-schaft]",
      "wordtype": "Substantiv",
      "description": "Gebiet, in dem du aufgewachsen bist oder dich zuhause fühlst; ein Ort, an den du immer wieder gerne zurückkehrst"
    },
    {
      "word":"Kalorien",
      "pronounce":"[Ka-lo-ri-en]",
      "wordtype": "Substantiv Plural",
      "description": "kleine Wesen, die nachts Kleidung enger nähen, Spiegel verbiegen und Gürtellöcher nach innen verschieben"
    },
    {
      "word":"Karma",
      "pronounce":"[Kar-ma]",
      "wordtype": "Substantiv",
      "description": "bedeutet, die letzte Rolle Klopapier aufzubrauchen ohne für Nachschub zu sorgen und anschließend die nächste Person zu sein, die auf Toilette muss"
    }
  ]
}
